// https://kb.ertelecom.ru/pages/viewpage.action?pageId=195003438#:~:text=%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%B4%D0%BB%D1%8F%20%D0%BE%D1%82%D0%BF%D1%80%D0%B0%D0%B2%D0%BA%D0%B8-,%D0%9F%D0%BE%D0%BB%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%BE%D0%B2%20%D0%BF%D0%BE%20%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%D1%83%20%D0%BA%D0%BB%D0%B8%D0%B5%D0%BD%D1%82%D0%B0%2C%20%D0%BF%D0%BE%D0%BB%D1%83%D1%87%D0%B5%D0%BD%D0%B8%D0%B5%20%D1%81%D0%BF%D0%B8%D1%81%D0%BA%D0%B0%20%D0%BA%D0%BE%D0%BD%D1%82%D0%B0%D0%BA%D1%82%D0%BE%D0%B2%20%D0%BF%D0%BE%20%D0%BD%D0%BE%D0%BC%D0%B5%D1%80%D1%83%20%D0%B4%D0%BE%D0%B3%D0%BE%D0%B2%D0%BE%D1%80%D0%B0,-%D0%9F%D0%B0%D1%80%D0%B0%D0%BC%D0%B5%D1%82%D1%80%3A%C2%A0get_agr_list_contact%20(%D0%B2%D1%8B%D0%B7%D0%BE%D0%B2
import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * @param contact - контакт клиента (телефон, e-mail, номер договора или шифрованный номер договора)
 * @param isActive - Флаг активности договора, 1 - да (по умолчанию), 0 - нет
 * Получение договора по контактным данным для неавторизованных
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Unauth/7f32e4176e22c9a59cfee31b2319b4d8
 */
const getContracts = (contact: string | number, isActive = true): IRequest => ({
    uri: '/v1/unauth/contract-asterisked',
    method: 'GET',
    withProvider: true,
    withAuth: false,
    queryParams: {
        contact,
        isActive: isActive ? 1 : 0,
    },
});

export type { ResponseDto, TContactData } from './dto/ResponseDto';

export default getContracts;
